import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ContentProvider } from "./content";
import { PublicDesignProvider } from "./content/design";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ContentProvider>
        <PublicDesignProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </PublicDesignProvider>
      </ContentProvider>
    </I18nextProvider>
  );
}

export default App;
